import { Typography } from "antd";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import PageLayout from "components/molecules/PageLayout";
import ReviewQueue from "components/organisms/ReviewQueue";
import UserBusinessAreaSchemaWrapper from "containers/UserBusinessAreaSchemaWrapper";
import { useParams } from "react-router-dom";

// The golden-record review queue of one schema. The wrapper resolves the business area and loads
// the schema (and its fields) from the names in the URL.
const ReviewQueuePage = () => {
    const { tenant, businessarea, schema } = useParams();

    return (
        <PageLayout
            key={`${businessarea}_${schema}_review_queue_page`}
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => (
                <SegmentContainer>
                    <Segment shadow>
                        <UserBusinessAreaSchemaWrapper key={`${businessarea}_${schema}_wrapper`} tenant={tenant} businessArea={businessarea.toLowerCase()} schema={schema}>
                            {(childProps) => (
                                <ReviewQueue
                                    tenant={tenant}
                                    businessArea={businessarea.toLowerCase()}
                                    schema={schema}
                                    setBreadcrumbNavigationItems={setBreadcrumbNavigationItems}
                                    {...childProps}
                                />
                            )}
                        </UserBusinessAreaSchemaWrapper>
                    </Segment>
                </SegmentContainer>
            )}
            helpContent={
                <Typography>
                    Clusters deduplication could not act on: records that changed after the duplicate search, and merges whose field values need a steward's decision.
                </Typography>
            }
        ></PageLayout>
    );
};

export default ReviewQueuePage;
